// extracted by mini-css-extract-plugin
export default {"container":"NoAttachmentsMessage_container__fj7a9","text":"NoAttachmentsMessage_text__y48gW"};